import { atom } from "recoil";
import { IJobsDetails, SelectedRowsToDelete } from "../types";

export const jobShowState = atom({
  key: "jobShowState",
  default: false,
});
export const addShowState = atom({
  key: "addShowState",
  default: false,
});
export const editState = atom({
  key: "editState",
  default: false,
});

export const rowForEdit = atom<IJobsDetails | undefined>({
  key: "rowForEdit",
  default: undefined,
});

export const jobSaving = atom({
  key: "jobSaving",
  default: false,
});

export const selectedRowsJobToDelete = atom<SelectedRowsToDelete | undefined>({
  key: "selectedRowsJobToDelete",
  default: undefined,
});

export const reportScript = atom({
  key: "reportScript",
  default: "",
});
export const scriptChange = atom({
  key: "scriptChange",
  default: false,
});
